import { userGroupsSelector } from "@/react/store/userSlice";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { getRoles } from "@/react/services/rbac/permissionToRole";
import { TAP_TOOLS_SUPER } from "@/react/services/rbac/groups";

export const usePermissions = () => {
  const userGroups = useSelector(userGroupsSelector);

  const isAdmin = userGroups.includes(TAP_TOOLS_SUPER);

  const hasPermission = useCallback(
    (permission) => {
      if (isAdmin) {
        return true;
      }

      const permissionGroups = getRoles(permission);
      if (permissionGroups.length === 0) {
        return false;
      }

      return permissionGroups.some((group) => userGroups.includes(group));
    },
    [userGroups]
  );

  return {
    hasPermission,
  };
};
